module.exports = __webpack_public_path__ + "img/withdrawal.0a09d868.png";